// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/theme.scss
// module id = 545
// module chunks = 4